import type {SearchRules} from '../../types';
import {SearchTypeCustom} from '../constants';

export const rulesContainCustom = (searchRules: Partial<SearchRules>) => {
	return (
		!!searchRules.elementTypes &&
		searchRules.elementTypes.some(
			(elementType) => elementType === SearchTypeCustom,
		)
	);
};
